/* eslint-disable react/display-name */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Popover from '@material-ui/core/Popover';
import { makeStyles } from '@material-ui/core/styles';
import { moreListTooltipStyles } from '@constants/mui-theme';
import CountAvatar from '@shared/count-avatar';
import './user-teams.scss';

const useStyles = makeStyles(() => ({
  popover: {
    pointerEvents: 'none'
  },
  paper: {
    ...moreListTooltipStyles.tooltip,
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
  }
}));

const UserTeams = ({ roles, userRoles }) => {
  const classes = useStyles();
  const [anchorPosition, setAnchorPosition] = useState(null);

  const handleMouseEnter = useCallback(event => {
    setAnchorPosition({
      top: event.clientY,
      left: event.clientX
    });
  }, []);

  const handleMouseLeave = useCallback(() => {
    setAnchorPosition(null);
  }, []);

  const handleMouseMove = useCallback(event => {
    setAnchorPosition({
      top: event.clientY,
      left: event.clientX
    });
  }, []);

  const open = Boolean(anchorPosition);

  const renderItem = (item, index) => (
    <div key={index} styleName="tooltip-item">
      {userRoles[item].name}
    </div>
  );

  const renderList = list => (
    <div>
      {list.map((item, index) => renderItem(item, index))}
    </div>
  );

  const renderAvatar = (list, value) => (
    <div
      onMouseOver={handleMouseEnter}
      onMouseOut={handleMouseLeave}
      onMouseMove={handleMouseMove}
    >
      <CountAvatar count={value} />
      <Popover
        className={classes.popover}
        classes={{ paper: classes.paper }}
        open={open}
        anchorReference="anchorPosition"
        anchorPosition={anchorPosition || { top: 0, left: 0 }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        disableRestoreFocus
      >
        {renderList(list)}
      </Popover>
    </div>
  );

  return (
    <div styleName="column-container">
      <div styleName="team-label">{userRoles[roles[0]].name}</div>
      {roles.length > 1 && renderAvatar(roles.slice(1), `+${roles.length - 1}`)}
    </div>
  );
};

UserTeams.propTypes = {
  roles: PropTypes.array,
  userRoles: PropTypes.object
};

export default UserTeams;
